import React from 'react';
import { Navbar } from '../components/Navbar';
import { Footer } from '../components/Footer';
interface TermsPageProps {
  onNavigate?: (path: string) => void;
}
export function TermsPage({
  onNavigate
}: TermsPageProps) {
  return <div className="min-h-screen bg-[#f5f5f7] text-[#1f2933]" data-id="element-1879">
      <Navbar onNavigate={onNavigate} data-id="element-1880" />

      <section className="py-24" data-id="element-1881">
        <div className="mx-auto max-w-4xl px-4 sm:px-6 lg:px-8" data-id="element-1882">
          <h1 className="text-4xl font-bold mb-8" data-id="element-1883">Terms of Service</h1>
          <p className="text-sm text-[#9ca3af] font-mono mb-12" data-id="element-1884">
            Last updated: {new Date().toLocaleDateString()}
          </p>

          <div className="space-y-8 bg-white border-2 border-dashed border-[#9ca3af] p-8" data-id="element-1885">
            <section data-id="element-1886">
              <h2 className="text-2xl font-bold mb-4" data-id="element-1887">1. Agreement to Terms</h2>
              <p className="text-[#1f2933]/80 mb-4" data-id="element-1888">
                By accessing The Authority Engine program, you agree to be bound
                by these Terms of Service and all applicable laws and
                regulations. If you do not agree with any of these terms, you
                are prohibited from using or accessing this program.
              </p>
            </section>

            <section data-id="element-1889">
              <h2 className="text-2xl font-bold mb-4" data-id="element-1890">2. Program Access</h2>
              <p className="text-[#1f2933]/80 mb-4" data-id="element-1891">
                Upon payment, you will receive lifetime access to The Authority
                Engine program materials, including all 10 core modules,
                accountability pod membership, and community access.
              </p>
              <p className="text-[#1f2933]/80" data-id="element-1892">
                The program runs for 2 months with weekend sessions (Sunday
                evenings). Session times may be adjusted based on community
                consensus.
              </p>
            </section>

            <section data-id="element-1893">
              <h2 className="text-2xl font-bold mb-4" data-id="element-1894">3. Payment Terms</h2>
              <p className="text-[#1f2933]/80 mb-4" data-id="element-1895">
                The program fee is ₦35,000 (early bird rate, 50% off) until
                January 31st, 2026. After this date, the standard rate of
                ₦70,000 applies. All payments are processed securely through
                Selar.
              </p>
              <p className="text-[#1f2933]/80" data-id="element-1896">
                Payments are non-refundable after 7 days of program
                commencement.
              </p>
            </section>

            <section data-id="element-1897">
              <h2 className="text-2xl font-bold mb-4" data-id="element-1898">
                4. Intellectual Property
              </h2>
              <p className="text-[#1f2933]/80" data-id="element-1899">
                All program materials, including but not limited to course
                content, templates, frameworks, and resources, are the
                intellectual property of The Networking Salon Ltd. You may not
                reproduce, distribute, or create derivative works without
                explicit written permission.
              </p>
            </section>

            <section data-id="element-1900">
              <h2 className="text-2xl font-bold mb-4" data-id="element-1901">5. User Conduct</h2>
              <p className="text-[#1f2933]/80 mb-4" data-id="element-1902">
                Participants are expected to:
              </p>
              <ul className="list-disc pl-6 space-y-2 text-[#1f2933]/80" data-id="element-1903">
                <li data-id="element-1904">
                  Engage respectfully with fellow participants and facilitators
                </li>
                <li data-id="element-1905">
                  Maintain confidentiality of shared information within pods
                </li>
                <li data-id="element-1906">Attend scheduled sessions and complete assignments</li>
                <li data-id="element-1907">Provide constructive feedback to peers</li>
              </ul>
            </section>

            <section data-id="element-1908">
              <h2 className="text-2xl font-bold mb-4" data-id="element-1909">
                6. Limitation of Liability
              </h2>
              <p className="text-[#1f2933]/80" data-id="element-1910">
                The Authority Engine provides educational content and systems.
                Results may vary based on individual effort, market conditions,
                and other factors. We make no guarantees of specific outcomes or
                income levels.
              </p>
            </section>

            <section data-id="element-1911">
              <h2 className="text-2xl font-bold mb-4" data-id="element-1912">7. Modifications</h2>
              <p className="text-[#1f2933]/80" data-id="element-1913">
                We reserve the right to modify these terms at any time.
                Participants will be notified of significant changes via email
                or community announcements.
              </p>
            </section>

            <section data-id="element-1914">
              <h2 className="text-2xl font-bold mb-4" data-id="element-1915">8. Contact</h2>
              <p className="text-[#1f2933]/80" data-id="element-1916">
                For questions about these Terms of Service, please contact us
                through our community WhatsApp group or email support.
              </p>
            </section>
          </div>
        </div>
      </section>

      <Footer onNavigate={onNavigate} data-id="element-1917" />
    </div>;
}